import doc                   from '@widesk-core/decorators/doc';
import AbstractPlanningModel from './AbstractPlanningModel';
import { Translatable }      from '@widesk-core/decorators/translatable';
import appStore              from '@/stores/appStore';

@doc.urnResource('planning')
@doc.translatable({ title: true })
class PlanningModel extends AbstractPlanningModel {
	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	static get urlPrefix() {
		return `${appStore.websiteEntertainment?.url}/planning/`;
	}

	getUrl(complete = false) {
		const path = PlanningModel.urlPrefix + this.slug;
		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}
}

interface PlanningModel
	extends Translatable<{ title: true }> {
}

export default PlanningModel;
